import { useEffect, useState } from 'react';
import API_URL from '../../apiConfig';

function Messages() {
  const [allMsg, setallMsg] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [selectedMsg, setSelectedMsg] = useState(null);

  const fetchAllMessages = async () => {
    try {
      setLoading(true);
      const res = await fetch(`${API_URL}/api/messages/allmessages`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
        credentials: "include"
      });
      const data = await res.json();
      if (data.success) {
        setallMsg(data.messages);
      } else {
        setError("Impossible de charger les données");
      }
    } catch (err) {
      console.error("🚨 Erreur fetchAllMessages:", err);
      setError("Erreur serveur lors de la récupération des messages.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllMessages();
    document.title = "LAMP | Admin - Messages";
  }, []);

  return (
    <div className="container-fluid py-4 animate__animated animate__fadeIn">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h2 className="fw-bold outfit text-dark">💬 Messages Reçus</h2>
        <span className="badge bg-primary px-3 py-2 rounded-pill shadow-sm">{allMsg.length} messages</span>
      </div>

      {error && (
        <div className="alert alert-danger d-flex align-items-center gap-2" role="alert">
          <i className="bi bi-exclamation-triangle-fill"></i>
          {error}
        </div>
      )}

      {loading ? (
        <div className="text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
            <p className="mt-2 text-muted small">Récupération de vos messages...</p>
        </div>
      ) : (
        <div className="row g-4 align-items-start">
          {allMsg.length > 0 ? (
            allMsg.map((m) => {
              const id = m.idMessage || m.idmessage || m.id_msg || m.idmsg;
              const nom = m.nomExp || m.nomexp || "Expéditeur inconnu";
              const email = m.emailExp || m.emailexp || "";
              const sujet = m.sujet || "";
              const contenu = m.contenu || m.msg || "";
              const date = m.dateEnvoi || m.dateenvoi || m.date_envoi || new Date();

              return (
                <div key={id} className="col-md-6 col-xl-4">
                  <div className="card-custom border-0 shadow-sm p-4 rounded-4 bg-white transition d-flex flex-column hover-shadow position-relative h-auto">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="d-flex align-items-center gap-3 w-75">
                        <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '45px', height: '45px' }}>
                          <span className="fw-bold fs-5 outfit">{nom.charAt(0).toUpperCase()}</span>
                        </div>
                        <div className="overflow-hidden">
                          <h6 className="mb-0 fw-bold text-dark text-truncate">{nom}</h6>
                          <a href={`mailto:${email}`} className="text-muted extra-small text-truncate d-block text-decoration-none">
                            {email}
                          </a>
                        </div>
                      </div>
                      <span className="badge bg-light text-muted fw-normal rounded-pill border small">
                          {new Date(date).toLocaleDateString()}
                      </span>
                    </div>
                    
                    <div className="mb-3">
                      <h6 className="fw-bold text-dark small mb-2">{sujet}</h6>
                      <p className="text-muted small mb-0 lh-sm bg-light bg-opacity-50 p-3 rounded-3 border border-light" style={{ display: '-webkit-box', WebkitLineClamp: '6', WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                        {contenu}
                      </p>
                    </div>
                    
                    <div className="mt-3 d-flex justify-content-between align-items-center pt-3 border-top border-light">
                      <div 
                        className="extra-small text-primary fw-bold cursor-pointer" 
                        role="button" 
                        onClick={() => setSelectedMsg({ id, nom, email, sujet, contenu, date })}
                      >
                          <i className="bi bi-eye me-1"></i> LIRE COMPLET
                      </div>
                      <div className="d-flex gap-2">
                          <a href={`mailto:${email}?subject=Re: ${sujet}`} className="btn btn-sm btn-primary rounded-pill px-3 shadow-none extra-small">
                              <i className="bi bi-reply-fill me-1"></i> Répondre
                          </a>
                          <button 
                            onClick={async () => {
                                if(window.confirm("Supprimer ce message ?")) {
                                    try {
                                        const res = await fetch(`${API_URL}/api/messages/delete/${id}`, { method: 'DELETE', credentials: 'include' });
                                        if(res.ok) fetchAllMessages();
                                    } catch(e) {}
                                }
                            }}
                            className="btn btn-sm btn-light text-danger rounded-circle border shadow-none" 
                            style={{ width: '32px', height: '32px', padding: 0 }} 
                            title="Supprimer"
                          >
                              <i className="bi bi-trash-fill small"></i>
                          </button>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="col-12">
              <div className="text-center py-5 bg-white rounded-4 shadow-sm border border-dashed border-2">
                <i className="bi bi-chat-left-dots fs-1 mb-2 d-block opacity-25 text-primary"></i>
                <p className="text-muted mt-2 fw-medium">Votre boîte de réception est vide.</p>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Modal Message Complet */}
      {selectedMsg && (
          <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060 }}>
              <div className="modal-dialog modal-dialog-centered">
                  <div className="modal-content border-0 rounded-4 shadow-lg animate__animated animate__zoomIn animate__faster">
                      <div className="modal-header border-0 pb-0">
                          <h5 className="modal-title outfit fw-bold">Détails du message</h5>
                          <button type="button" className="btn-close shadow-none" onClick={() => setSelectedMsg(null)}></button>
                      </div>
                      <div className="modal-body p-4">
                          <div className="d-flex align-items-center gap-3 mb-4 bg-light p-3 rounded-4">
                              <div className="bg-primary bg-opacity-10 text-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: '50px', height: '50px' }}>
                                  <span className="fw-bold fs-4 outfit">{selectedMsg.nom.charAt(0).toUpperCase()}</span>
                              </div>
                              <div>
                                  <h6 className="fw-bold mb-0 text-dark">{selectedMsg.nom}</h6>
                                  <p className="text-muted mb-0 small">{selectedMsg.email}</p>
                              </div>
                          </div>
                          
                          <div className="mb-4">
                              <div className="d-flex justify-content-between mb-3">
                                  <span className="badge bg-light text-muted border">{new Date(selectedMsg.date).toLocaleString()}</span>
                              </div>
                              <h6 className="fw-bold text-dark mb-2">Sujet: {selectedMsg.sujet}</h6>
                              <div className="p-3 bg-white border border-light rounded-4 text-muted lh-lg" style={{ whiteSpace: 'pre-wrap', maxHeight: '400px', overflowY: 'auto' }}>
                                  {selectedMsg.contenu}
                              </div>
                          </div>

                          <div className="text-end border-top pt-3">
                              <a href={`mailto:${selectedMsg.email}?subject=Re: ${selectedMsg.sujet}`} className="btn btn-primary rounded-pill px-4 fw-bold">
                                  <i className="bi bi-reply-fill me-2"></i> Envoyer une réponse
                              </a>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      )}

      <style>{`
        .hover-shadow:hover { box-shadow: 0 15px 30px rgba(0,0,0,0.1) !important; transform: translateY(-5px); }
        .extra-small { font-size: 0.75rem; }
        .card-custom { transition: all 0.3s ease; }
      `}</style>
    </div>
  );
}

export default Messages;